<template>
  <section id="about" class="about">
    <!-- タイトル・サブタイトル -->
    <div class="text-wrapper">
      <h1 class="title">{{ $t('page.about.title') }}</h1>
      <div class="sub-title">{{ $t('page.about.sub-title') }}</div>
    </div>

    <!-- メインビジュアル -->
    <div class="main-visual">
      <img class="image" src="~/assets/pages/about/ImageAboutMain.webp" alt="" />
    </div>

    <!-- メインテキスト -->
    <div class="about-content">
      <p
        v-for="(text, index) in $tm('page.about.about-content.texts')"
        v-html="$rt(text)"
        class="text"
        :key="index"
      />
    </div>

    <!-- サブ -->
    <div class="about-content-sub">
      <div class="about-content-sub-col">
        <div class="sub-text">
          <p class="subject" v-html="$t('page.about.about-content-2.subject')"></p>
          <p
            v-for="(text, index) in $tm('page.about.about-content-2.texts')"
            v-html="$rt(text)"
            class="text"
            :key="index"
          />
        </div>
        <div class="sub-visual-feature">
          <img class="image" src="~/assets/pages/about/ImageAboutFeature01.webp" alt="" />
        </div>
      </div>
      <div class="sub-visual-feature-wide">
        <img class="image" src="~/assets/pages/about/ImageAboutFeatureWide01.webp" alt="" />
      </div>
    </div>

    <div class="about-content-sub">
      <div class="about-content-sub-col-2">
        <div class="sub-visual-feature-2">
          <img class="image" src="~/assets/pages/about/ImageAboutFeature02.webp" alt="" />
        </div>
        <div class="sub-text">
          <p class="subject" v-html="$t('page.about.about-content-3.subject')"></p>
          <p
            v-for="(text, index) in $tm('page.about.about-content-3.texts')"
            v-html="$rt(text)"
            class="text"
            :key="index"
          />
        </div>
      </div>
      <div class="sub-visual-feature-wide-2">
        <img class="image" src="~/assets/pages/about/ImageAboutFeatureWide02.webp" alt="" />
      </div>
    </div>
  </section>

  <!-- 背景透過部分 -->
  <div class="about-margin-bottom" />
</template>
<script setup lang="ts">
</script>
<style lang="scss" scoped>
@use '@/assets/styles/mixins' as m;
@use '@/assets/styles/variables' as v;
@use '@/assets/styles/util' as u;

#about {
  background: v.$common-white-color;
  padding: 160px 0;
  text-align: center;
  /* 言語セレクタの高さ打ち消し用 */
  margin-top: -56px;
  @include m.sp() {
    margin-top: 0;
    padding: 74px 0 64px;
  }
}

.text-wrapper {

  .title {
    color: v.$accent-color;
    font-size: 1.125rem;
    font-family: v.$accent-font-family;
    font-weight: v.$font-weight-light;
    margin: 0;
    @include m.sp() {
      font-size: 1rem;
      letter-spacing: 6.4px;
    }
  }

  .sub-title {
    color: v.$text-title-color;
    font-size: 1.375rem;
    line-height: 1.5;
    @include m.sp() {
      font-size: 1.25rem;
      letter-spacing: 3px;
    }
  }
}

.main-visual {
  margin: 96px auto;
  max-width: 1280px;
  @include m.sp() {
    margin: 29px auto 32px;
    padding: 0;
  }
}

.sub-visual-feature {
  max-width: 520px;
  @include m.sp() {
    max-width: 45vw;
    margin: 0 auto;
  }
}
.sub-visual-feature-wide {
  margin: 32px 0 0;
  max-width: calc(1280px + 6%);
  padding: 0 3%;
}
.sub-visual-feature-2 {
  max-width: 520px;
  @include m.sp() {
    max-width: 45vw;
    margin: 0 auto;
  }
}
.sub-visual-feature-wide-2 {
  margin: 32px 0 0;
  max-width: calc(1280px + 6%);
  padding: 0 3%;
}

/* 天比登都の説明 */
.about-content {
  margin: 86px auto 0;
  /* max-width: calc(1280px + 6%); */
  max-width: 800px;
  padding: 0 3%;
  @include m.sp() {
    margin-top: 0;
    padding: 0 16px;
  }

  .text {
    margin-top: 40px;
    line-height: 2.4;
    /* 画面が狭くなった時にwbrで区切り毎に改行 */
    word-break: keep-all;
    @include m.sp() {
      margin-top: 0;
      font-size: 0.875rem;
      letter-spacing: 2.1px;
    }
  }
}

.about-content-sub {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 168px;
  flex-wrap: wrap;
  @include m.sp() {
    margin-top: 85px;
  }
}
.about-content-sub-col {
  display: flex;
  justify-content: space-between;
  width: 100%;
  max-width: calc(1280px + 6%);
  padding: 0 3%;
  gap: 20px;
  @include m.sp() {
    flex-direction: column-reverse;
    gap: 0px;
  }
}
.about-content-sub-col-2 {
  display: flex;
  justify-content: space-between;
  width: 100%;
  max-width: calc(1280px + 6%);
  padding: 0 3%;
  gap: 20px;
  @include m.sp() {
    flex-direction: column;
    gap: 0px;
  }
}
.sub-text {
  text-align: left;
  max-width: 640px;
  align-content: center;
  word-break: keep-all;
  margin:0 24px;

  @include m.sp() {
    text-align: center;
  }

  .subject {
    font-size: 1.5rem;
    line-height: 1.5;
    margin: 1rem 0 2rem;
    padding-bottom: min(10vw - 64px, 56px);
    word-break: keep-all;
    @include m.sp() {
      font-size: 1.25rem;
      padding-bottom: 0;
    }
  }

  .text {
    font-size: 1rem;
    margin: 0;
    line-height: 2.4;
    @include m.sp() {
      font-size: 0.875rem;
      margin-top: 0;
    }
  }
}

/* About下の余白 */
.about-margin-bottom {
  height: 440px;
  background: v.$bg-cover-color;
  @include m.sp() {
    height: 200px;
  }
}
</style>
